<template>
    <div id="new_converter">
        <h1 class="ui header">{{ converter.name }} 翻譯本</h1>
        <div v-if="is_initialized">
            <form class="ui form">
                <div class="field">
                    <label>名稱</label>
                    <input type="text" v-model="converter.name">
                </div>
                <div class="field">
                    <label>類別</label>
                    <input type="text" v-model="converter.category">
                </div>
                <div class="field">
                    <label>供應商</label>
                    <input type="text" v-model="converter.provider">
                </div>
                <div class="field">
                    <label>Name Row</label>
                    <input type="number" v-model="converter.name_row">
                </div>
                <div class="field">
                    <label>Data Offset</label>
                    <input type="number" v-model="converter.data_offset">
                </div>
                <div class="field">
                    <label>Data Bound</label>
                    <input type="number" v-model="converter.data_bound">
                </div>
                <div class="ui divider"></div>
                <div class="ui segments">
                    <div
                        v-for="attribute_conversion in converter.attribute_conversions"
                        :attribute_conversion="attribute_conversion"
                        class="ui segment"
                        :class="{
                            disabled: attribute_conversion._delete
                        }"
                    >
                        <a class="ui right corner label" :class="{ green: attribute_conversion._delete, red: !attribute_conversion._delete }" @click.prevent="toggle_delete(attribute_conversion)">
                            <i v-if="attribute_conversion._delete" class="undo icon"></i>
                            <i v-else class="remove icon"></i>
                        </a>
                        <h3 class="ui header">{{ attribute_conversion.header_text }}</h3>
                        <div class="field" :class="{disabled: attribute_conversion._delete}">
                            <label>Header Text</label>
                            <input type="text" v-model="attribute_conversion.header_text">
                        </div>
                        <div class="field" :class="{disabled: attribute_conversion._delete}">
                            <label>Attribute Name</label>
                            <input type="text" v-model="attribute_conversion.attribute_name">
                        </div>
                        <div class="field" :class="{disabled: attribute_conversion._delete}">
                            <label>Sort</label>
                            <input type="number" v-model="attribute_conversion.sort">
                        </div>
                        <div class="field" :class="{disabled: attribute_conversion._delete}">
                            <label>Is Auto Refer?</label>
                            <input type="checkbox" v-model="attribute_conversion.is_auto_refer">
                        </div>
                    </div>
                    <div class="ui segment">
                        <button class="ui basic positive fluid button" @click.prevent="add_attribute_conversion">
                            <i class="plus icon"></i>
                            新增條目
                        </button>
                    </div>
                </div>
                <button class="ui basic positive button" @click.prevent="create">{{ $t('ui.general.create') }}</button>
            </form>
        </div>
    </div>
</template>

<script>
export default {
    props: {
    },
    data: function () {
        return {
            is_initialized: false,
            is_processing: false,
            converter: {},
            errors: [],
        }
    },
    computed: {
        create_converter_url: function() {
            return this.$store.state.admin.converters_module.admin_converters_routes.create;
        }
    },
    created: function() {
        this.init();
    },
    mounted: function() {
    },
    watch: {
        '$route' (to, from) {
            if (to.name == "new_converter") {
                this.init();
            }
        },
    },
    methods: {
        init: async function() {
            var that = this;
            await new Promise(resolve => {
                that.is_initialized =  false;
                that.is_processing =  false;
                that.converter =  {
                    name: "新翻譯本",
                    attribute_conversions: [],
                };
                that.errors =  [];
                resolve();
            });
            await new Promise(resolve => {
                that.is_initialized = true;
                resolve();
            });
        },
        toggle_delete: function(attribute_conversion) {
            var that = this;
            attribute_conversion._delete = !attribute_conversion._delete;
        },
        add_attribute_conversion: function() {
            var that = this;
            that.converter.attribute_conversions.push({
                header_text: "新條目",
                _delete: false,
            });
        },
        create: function() {
            var that = this;
            that.is_processing = true;
            that.errors = [];
            // Prepare parameters
            var params = that.converter;
            params.attribute_conversions_attributes = _.extend({}, params.attribute_conversions);
            delete params["attribute_conversions"];
            var url = new RestUrl(that.create_converter_url).parse(
                {},
                ""
            );

            axios.post(url, {
                converter: params
            }).then(function (response) {
                if (response.data.status == "success") {
                    that.$router.push('/admin/converters');
                    // that.$noty.success("翻譯本建立成功");
                    that.$noty.success(
                        that.$t('ui.notifications.success.create__name', {
                            name: '翻譯本'
                        })
                    );
                } else {
                    // that.$noty.error("翻譯本建立失敗");
                    that.$noty.error(
                        that.$t('ui.notifications.error.create__name', {
                            name: '翻譯本',
                            reason: + ": " + response.data.errors,
                        })
                    );
                    that.errors = response.data.errors;
                }
            })
            .catch(function (error) {
                if (!error.response) {
                    // Network Error
                    that.$noty.error(
                        that.$t('ui.general.network_abnormality')+": "+
                        that.$t('ui.general.server_offline')
                    );
                } else {
                    that.$noty.error(that.$t('ui.general.network_abnormality')+': ' + error.response.status + error.response.data);
                }
            });
            that.is_processing = false;
        },
    },
    components: {
    }
}
</script>

<style scoped>
</style>
